import {
    SET_APPLIED_PERMISSIONS,
    SET_PRIV_MANAGER_ROLE_SELECTED_PERMISSIONS,
    SET_PAGES,
    SET_TEST_PERMISSIONS,
    CANCEL_PERMISSIONS,
    SET_USER_LOGIN
} from "../actions/types";

const fromStoragePermissions = JSON.parse(localStorage.getItem("permissions"));
const fromStorageUser = JSON.parse(localStorage.getItem("user"));

const initialState = fromStoragePermissions ?
    {
        //For current user:
        appliedPermissions: fromStoragePermissions,
        testPermissions: [],
        //For Privilege Manager Roles/Privileges Modifications:
        privManagerRoleSelectedPermissions: [],
        pages: [],
        user: fromStorageUser
    }
    :
    {
        appliedPermissions: [],
        testPermissions: [],
        privManagerRoleSelectedPermissions: [],
        pages: [],
        user: {}
    //    [
    //        { key: '53', value: '1111111111' },
    //        { key: '521', value: '1111111111' },
    //        { key: '52', value: '1111111111' },
    //        { key: '511', value: '1111111111' },
    //        { key: '51', value: '1111111111' },
    //        { key: '5', value: '1' },
    //        { key: '41', value: '1111111111' },
    //        { key: '4', value: '1' },
    //        { key: '31', value: '1111111111' },
    //        { key: '3', value: '1' },
    //        { key: '211', value: '1111111111' },
    //        { key: '21', value: '1111111111' },
    //        { key: '2', value: '1' },
    //        { key: '111', value: '1111111111' },
    //        { key: '11', value: '1111111111' },
    //        { key: '1', value: '1' },
    //]
    }
;

const PrivilegeManagerReducer = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {

        case SET_APPLIED_PERMISSIONS:
            if (payload !== undefined) {
                return { ...state, appliedPermissions: payload };
            } else {
                return { ...state, appliedPermissions: initialState.appliedPermissions }
            }
        case SET_TEST_PERMISSIONS:
            return { ...state, testPermissions: payload };

        case SET_PRIV_MANAGER_ROLE_SELECTED_PERMISSIONS:
            return { ...state, privManagerRoleSelectedPermissions: payload }

        case SET_PAGES:
            return { ...state, pages: payload }

        case CANCEL_PERMISSIONS:
            return { ...state, appliedPermissions: [] }

        case SET_USER_LOGIN:
            if (payload !== undefined) {
                return { ...state, user: payload };
            } else {
                return { ...state, user: initialState.user }
            }

        default:
            return state;
    }
};

export default PrivilegeManagerReducer;